/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { MutableRef } from 'preact/hooks';
import { useDatatip } from '#hooks/PRIVATE_useDatatip';

export function useMeterDatatip(
  value: number,
  isPointerActiveRef: MutableRef<boolean>,
  datatip?: string | null,
  ariaDescribedBy?: string
) {
  const datatipText = datatip === undefined ? `${value}` : datatip;
  const { datatipContent, datatipProps } = useDatatip({
    content: datatipText,
    anchor: isPointerActiveRef.current ? 'pointer' : 'element',
    offset: {
      mainAxis: 8,
      crossAxis: 0
    },
    placement: 'top',
    touchResponse: 'touchStart'
  });

  datatipProps['aria-describedby'] =
    [ariaDescribedBy, datatipProps['aria-describedby']].filter(Boolean).join(' ') || undefined;

  return { datatipContent, datatipProps };
}
